import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FirstWinViewButtonPicker from 'Views/Page/Content/Templates/SwitchViewTemplate/FirstWinViewButtonPicker';
import AumHouseholdViewButtonPicker from 'Views/Page/Content/Templates/SwitchViewTemplate/AumHouseholdViewButtonPicker';
import TaskStatusViewButtonPicker from 'Views/Page/Content/Templates/SwitchViewTemplate/TaskStatusViewButtonPicker';
import PaymentChangeViewButtonPicker
  from 'Views/Page/Content/Templates/SwitchViewTemplate/PaymentChangeViewButtonPicker';
import LinkedAccountErrorViewPicker
  from 'Views/Page/Content/Templates/SwitchViewTemplate/LinkedAccountErrorViewButtonPicker';
import DigitalOnboardingViewButtonPicker from './DigitalOnboardingViewButtonPicker';
import ClientViewButtonPicker from './ClientViewButtonPicker';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
});

const SwitchViewTemplate = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Header
        className={classes.title}
        title={pageContentResource.attr('title')}
      />
      <DigitalOnboardingViewButtonPicker className={classes.button} />
      <ClientViewButtonPicker className={classes.button} />
      <FirstWinViewButtonPicker className={classes.button} />
      <AumHouseholdViewButtonPicker className={classes.button} />
      <TaskStatusViewButtonPicker className={classes.button} />
      <PaymentChangeViewButtonPicker className={classes.button} />
      <LinkedAccountErrorViewPicker className={classes.button} />
    </Box>
  );
};

SwitchViewTemplate.defaultProps = {
  className: '',
};

SwitchViewTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SwitchViewTemplate);
